import type { ReactNode } from 'react';

export const symbol_1x_mobiledata_badge: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h760q24 0 42 18t18 42v600q0 24-18 42t-42 18H100Zm0-60h760v-600H100v600Zm0 0v-600 600Zm182-440v310q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-340q0-12.75-8.62-21.38Q324.75-680 312-680h-82q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h52Zm328 186 79 140q4 7 10.15 10.5 6.16 3.5 13.85 3.5 16.5 0 24.75-14t.25-28l-92-164 85-152q8-14 0-28t-24.52-14q-8.26 0-14.87 3.5Q685-673 681-666l-71 129-71-128q-4.03-6.67-10.48-10.83Q522.06-680 514-680q-16.5 0-24.75 14t-.25 28l85 152-91 164q-8 14 0 28t24.52 14q8.26 0 14.87-4 6.61-4 10.61-11l77-139Z"
		/>
	</svg>
);
